import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationScenarioCard } from "web_myplann/Inspiration/Components/InspirationScenarioCard";
import { RETIREMENT_MAX_SHOWN_COVERAGE } from "web_myplann/Inspiration/Retirement/constants";
import type {
	RetirementScenario,
	RetirementScenarioKey,
} from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";
import { formatPercentage } from "web_myplann/Shared/Utils/percentageFormatters";

const R = Resources.Inspiration.Retirement;

type Props = {
	scenarios: RetirementScenario[];
	selected: RetirementScenarioKey;
	onSelect: (key: RetirementScenarioKey) => void;
};

export const RetirementScenarioList: FC<Props> = ({
	scenarios,
	selected,
	onSelect,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack direction="row" gap={theme.spacingTokens.sm}>
			{scenarios.map((scenario) => (
				<InspirationScenarioCard
					key={scenario.key}
					scenarioKey={scenario.key}
					rate={scenario.rate}
					value={formatPercentage(
						Math.min(RETIREMENT_MAX_SHOWN_COVERAGE, scenario.coverage),
						0,
					)}
					note={`~${formatInspirationMoney(scenario.total)}`}
					recommendedLabel={
						scenario.recommended ? t(R.scenarioRecommended) : undefined
					}
					selected={scenario.key === selected}
					onClick={() => onSelect(scenario.key)}
				/>
			))}
		</Stack>
	);
};
